/**
 * Module-scoped flag that tracks whether the current page session started
 * from a real username/password or MFA login (as opposed to a page reload
 * or silent token refresh).
 *
 * The flag lives only in memory, so it is always cleared when the page is
 * reloaded. It is set by `demoLoginEventMiddleware` and consumed exactly
 * once by `useDemoLoginEvent`.
 */
let freshLoginPending = false

/** Mark that a real login just completed. Called by the Redux middleware. */
export function markFreshLogin(): void {
  freshLoginPending = true
}

/**
 * Returns true and atomically clears the flag if a fresh login is pending.
 * Subsequent calls return false until the next real login.
 */
export function consumeFreshLogin(): boolean {
  if (!freshLoginPending) return false
  freshLoginPending = false
  return true
}

/** Clears the flag without consuming it. Called on logout. */
export function clearFreshLogin(): void {
  freshLoginPending = false
}
